import React from 'react';
import { ArrowRight, TrendingUp, Shield, Zap } from 'lucide-react';

const Hero = () => {
  return (
    <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="/images/ben-hershey-K9HgyI3qmqA-unsplash.webp" 
          alt="" 
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-gray-900/80 via-gray-800/80 to-gray-900/80"></div>
      </div>

      <div className="container mx-auto px-4 py-24 md:py-32 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6">
            <span className="bg-gradient-to-r from-pink-400 via-pink-500 to-pink-600 bg-clip-text text-transparent">
              Vos Parieurs,
            </span>
            <br />
            <span className="text-white">Votre Comparateur</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-2xl mx-auto">
            Trouvez instantanément les meilleures offres, bonus et cotes parmi les sites de paris français les plus fiables. Notre équipe teste, compare et vous guide vers les opportunités gagnantes.
          </p>
          
          {/* Navigation Links */}
          <div className="flex flex-wrap justify-center gap-3 mb-12">
            <a
              href="#offres"
              data-discover="true"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('offres')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-6 py-3 bg-gray-800/80 backdrop-blur-sm border border-pink-600/50 text-pink-400 rounded-lg font-semibold hover:bg-pink-600 hover:text-white hover:border-pink-600 transition-all"
            >
              Offres
            </a>
            <a
              href="#about"
              data-discover="true"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-6 py-3 bg-gray-800/80 backdrop-blur-sm border border-pink-600/50 text-pink-400 rounded-lg font-semibold hover:bg-pink-600 hover:text-white hover:border-pink-600 transition-all"
            >
              À Propos
            </a>
            <a
              href="#guides"
              data-discover="true"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('guides')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-6 py-3 bg-gray-800/80 backdrop-blur-sm border border-pink-600/50 text-pink-400 rounded-lg font-semibold hover:bg-pink-600 hover:text-white hover:border-pink-600 transition-all"
            >
              Guides
            </a>
            <a
              href="#faq"
              data-discover="true"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-6 py-3 bg-gray-800/80 backdrop-blur-sm border border-pink-600/50 text-pink-400 rounded-lg font-semibold hover:bg-pink-600 hover:text-white hover:border-pink-600 transition-all"
            >
              FAQ
            </a>
            <a
              href="#actualites"
              data-discover="true"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('actualites')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-6 py-3 bg-gray-800/80 backdrop-blur-sm border border-pink-600/50 text-pink-400 rounded-lg font-semibold hover:bg-pink-600 hover:text-white hover:border-pink-600 transition-all"
            >
              Actualités
            </a>
            <a
              href="#contact"
              data-discover="true"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-6 py-3 bg-gray-800/80 backdrop-blur-sm border border-pink-600/50 text-pink-400 rounded-lg font-semibold hover:bg-pink-600 hover:text-white hover:border-pink-600 transition-all"
            >
              Contact
            </a>
          </div>

          {/* Features */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16">
            <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-6 border border-pink-500/20">
              <div className="w-12 h-12 bg-pink-600 rounded-lg flex items-center justify-center mb-4 mx-auto">
                <TrendingUp className="text-white" size={24} />
              </div>
              <h3 className="text-white font-semibold mb-2">Meilleures Cotes</h3>
              <p className="text-gray-400 text-sm">Comparaison en temps réel des meilleures cotes disponibles sur le marché français.</p>
            </div>

            <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-6 border border-pink-500/20">
              <div className="w-12 h-12 bg-pink-600 rounded-lg flex items-center justify-center mb-4 mx-auto">
                <Shield className="text-white" size={24} />
              </div>
              <h3 className="text-white font-semibold mb-2">Sites Sécurisés</h3>
              <p className="text-gray-400 text-sm">Uniquement des opérateurs agréés par l'ANJ avec des licences françaises valides.</p>
            </div>

            <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-6 border border-pink-500/20">
              <div className="w-12 h-12 bg-pink-600 rounded-lg flex items-center justify-center mb-4 mx-auto">
                <Zap className="text-white" size={24} />
              </div>
              <h3 className="text-white font-semibold mb-2">Paiements Rapides</h3>
              <p className="text-gray-400 text-sm">Retraits rapides et sécurisés, informations vérifiées pour chaque site.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

